<template>
  <div class="card mt-4">
    <div class="table-responsive" style="min-height: 500px;">
      <div class="table-controls m-3 d-flex">
        <div class="controls-wrap d-flex align-items-center contact-filters">
          <!-- Integration Field -->
          <Search class="mr-3" placeholderText="Search (name and email)" @search="doSearch" />

          <div class="ml-auto mr-3">
            <v-select
              class="employer-dropdown"
              style="min-width: 250px"
              v-model="selectedCountry"
              @input="handleSearchFiltersNew"
              :options="getAllCountries"
              placeholder="All Countries"
              inputId="employer-select"
              label="name"
              :reduce="country => country.name"
              :clearable="true"
              ><!-- <template #option="{ name, city }"> {{ name }} - {{ city }} </template> --></v-select
            >
          </div>

          <div class="mr-3">
            <v-select
              class="employer-dropdown"
              style="min-width: 250px"
              v-model="selectedEmployers"
              @input="handleSearchFiltersNew"
              :options="employersDropdown"
              placeholder="All Employers"
              inputId="employer-select"
              label="name"
              multiple
              :reduce="employer => employer.id"
              :clearable="true"
              ><!-- <template #option="{ name, city }"> {{ name }} - {{ city }} </template> --></v-select
            >
          </div>

          <div class="mr-3">
            <v-select
              style="min-width: 250px"
              v-model="selectedUsers"
              @input="handleSearchFiltersNew"
              :options="users"
              placeholder="All Users"
              inputId="employer-select"
              label="user_name"
              multiple
              :reduce="employer => employer.user_id"
              :clearable="true"
              ><!-- <template #option="{ name, city }"> {{ name }} - {{ city }} </template> --></v-select
            >
          </div>
          <div class="mr-3">
            <v-select
              style="min-width: 250px"
              v-model="selectedDate"
              @input="handleSearchFiltersNew"
              :options="dates"
              placeholder="All Time"
              inputId="employer-select"
              label="label"
              :reduce="employer => employer.value"
              :clearable="true"
              ><!-- <template #option="{ name, city }"> {{ name }} - {{ city }} </template> --></v-select
            >
          </div>
          <div class="align-items-center published popover-show">
            <div
              v-show="!isPreviouslySubmited"
              class="published ms-auto text-center"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Include declined contacts"
              @click="
                isPreviouslySubmited = !isPreviouslySubmited;
                handleSearchFiltersNew($event);
              "
            >
              <span class="fa-stack fa-2x">
                <i
                  :class="isPreviouslySubmited ? 'is-clicked' : ''"
                  class="fas fa-user fa-stack-1x"
                ></i>
                <i
                  :class="isPreviouslySubmited ? 'is-clicked' : ''"
                  class="fas fa-ban fa-stack-2x"
                  style="color:red"
                ></i>
              </span>
            </div>

            <div
              class="published ms-auto text-center"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Exclude declined contacts"
              @click="
                isPreviouslySubmited = !isPreviouslySubmited;
                handleSearchFiltersNew($event);
              "
              v-show="isPreviouslySubmited"
            >
              <span class="fa-stack fa-2x">
                <i
                  :class="isPreviouslySubmited ? 'is-clicked' : ''"
                  class="fas fa-user fa-stack-1x"
                ></i>
                <i
                  :class="isPreviouslySubmited ? 'is-clicked' : ''"
                  class="fas fa-ban fa-stack-2x"
                  style="color:red"
                ></i>
              </span>
            </div>
          </div>
        </div>
      </div>

      <table class="table table-striped custom-table desktop-only-table">
        <thead class="bg-dark">
          <tr>
            <th style="min-width: 150px;" nowrap scope="col">Name</th>
            <th style="min-width: 150px;" nowrap scope="col">Employer</th>
            <th nowrap scope="col">Email</th>
            <th nowrap scope="col">Title</th>
            <th nowrap scope="col"></th>
            <th nowrap scope="col">Advertised job</th>
            <th nowrap scope="col">Score</th>
            <th nowrap scope="col">Toxicity</th>
            <th nowrap scope="col">Hubspot</th>
            <th nowrap scope="col">Created By</th>
            <th nowrap scope="col">Created</th>
            <th nowrap scope="col">&nbsp;</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="contact in contacts" :key="contact.id">
            <td>{{ contact.first_name }} {{ contact.last_name }}</td>
            <td id="title" nowrap>
              <router-link
                :to="{
                  name: 'employer_marketing_id',
                  params: { employer_id: contact.mm_employer.id },
                }"
                >{{ contact.mm_employer.name }}</router-link
              >
              <div>
                {{ contact.mm_employer.city ? `${contact.mm_employer.city}, ` : '' }}
                {{ contact.mm_employer.country ? `${contact.mm_employer.country}` : '' }}
              </div>
            </td>

            <td>
              <div style="display: flex; align-items: center; gap: 8px;">
                <popper
                  :append-to-body="true"
                  trigger="hover"
                  :options="{
                    placement: 'top',
                    modifiers: { offset: { offset: '10,20px' } },
                  }"
                >
                  <div class="popper">
                    {{
                      contact.email_premutator_status === 0 ? 'Single email' : 'Email permutator'
                    }}
                  </div>
                  <div slot="reference">
                    <div
                      :style="getIconColor(contact.email_premutator_status)"
                      style="display: flex; align-items: center;"
                      v-html="contact.email_premutator_status === 0 ? mailIcon : multipleMailIcon"
                    ></div>
                  </div>
                </popper>

                <popper
                  :append-to-body="true"
                  trigger="hover"
                  :options="{
                    placement: 'top',
                    modifiers: { offset: { offset: '10,20px' } },
                  }"
                >
                  <div class="popper">
                    {{ getLanguageName(contact.language) }}
                  </div>
                  <div slot="reference" style="display: flex; align-items: center;">
                    <span
                      :class="`fi fi-${getLanguageFlag(contact.language)}`"
                      style="border-radius: 2px; width: 20px; height: 15px; line-height: 15px; display: inline-block;"
                    ></span>
                  </div>
                </popper>

                <a :href="`mailto:${contact.email}`"> {{ contact.email }}</a>
              </div>
            </td>

            <td style="white-space: nowrap;">{{ contact.title }}</td>

            <td v-if="contact.linkedin">
              <a rel="nofollow" target="_blank" :href="contact.linkedin">
                <div style="width: 26px; height: 26px; fill: #0a66c2;" v-html="linkedinIcon"></div
              ></a>
            </td>
            <td v-else></td>
            <td>{{ contact.advertised_job }}</td>
            <td>{{ contact.bouncer_score }}</td>
            <td>{{ contact.bouncer_toxicity }}</td>

            <td
              :style="{
                backgroundColor: contact.hubspot_submitted ? '#f05a00' : '',
                color: contact.hubspot_submitted ? '#fff' : '',
                opacity: contact.only_newsletter === true ? 0.5 : 1,
              }"
            >
              <span v-if="contact.hubspot_submitted">
                {{
                  contact.hubspot_submitted
                    | formatDate({
                      format: getUserProfile.format_date,
                      timezone: getUserProfile.timezone,
                      hasHourAndMinutes: false,
                    })
                }}
              </span>
              <span v-else>
                {{ contact.exists_in_hubspot ? 'Existed' : '' }}
              </span>
            </td>

            <td style="white-space:nowrap;">{{ contact.created_by }}</td>
            <td>
              {{
                contact.created_at
                  | formatDate({
                    format: getUserProfile.format_date,
                    timezone: getUserProfile.timezone,
                    hasHourAndMinutes: false,
                  })
              }}
            </td>

            <td id="actions">
              <div class="icon-wrapper d-flex align-items-center">
                <button
                  @click="setAction(contact, 'edit')"
                  data-bs-target="#actionModal"
                  data-bs-toggle="modal"
                  class="btn btn-link"
                >
                  <svgHelper class="edit" name="edit" />
                </button>

                <button
                  v-if="getAccType === 'admin' && contact.email_premutator_status === 0"
                  @click="
                    contact.hubspot_submitted && !contact.exists_in_hubspot
                      ? ''
                      : setAction(contact, 'submit')
                  "
                  type="button"
                  :data-bs-target="
                    contact.hubspot_submitted && !contact.exists_in_hubspot ? '' : `#actionModal`
                  "
                  data-bs-toggle="modal"
                  class="btn btn-link"
                  :style="
                    contact.hubspot_submitted && !contact.exists_in_hubspot
                      ? 'opacity:0.5; cursor:disabled'
                      : ''
                  "
                >
                  <svgHelper class="submit" name="submitPipeline" />
                </button>

                <button
                  v-if="getAccType === 'admin' && contact.email_premutator_status != 0"
                  @click="contact.exists_in_hubspot ? setAction(contact, 'submit') : ''"
                  type="button"
                  :data-bs-target="contact.exists_in_hubspot ? `#actionModal` : ''"
                  data-bs-toggle="modal"
                  class="btn btn-link"
                  :style="!contact.exists_in_hubspot ? 'opacity:0.5; cursor:disabled' : ''"
                >
                  <svgHelper class="submit" name="submitPipeline" />
                </button>
                <button
                  v-if="getAccType === 'admin'"
                  @click="setAction(contact, 'delete')"
                  class="btn btn-link"
                  data-bs-toggle="modal"
                  data-bs-target="#actionModal"
                >
                  <svgHelper class="delete" name="delete" />
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <Spinner :isLoading="isLoading" />

    <div class="d-flex ml-auto mt-auto bottom-controls">
      <div class="d-none d-sm-block" id="pagination">
        <!-- Pagination -->

        <Pagination
          :currentPage="currentPage"
          :totalPages="totalPages"
          @nextPage="nextPage"
          @prevPage="previousPage"
          @selectPageByNumber="setPageByNumber"
          @firstPage="setToFirstPage"
          @lastPage="setToLastPage"
          @keyup="keymonitor"
        />
      </div>
    </div>

    <!-- Modal (Bootstrap 5) -->
    <div
      class="modal fade add-user-modal"
      id="actionModal"
      tabindex="-1"
      aria-labelledby="actionModalLabel"
      aria-hidden="true"
      data-bs-keyboard="false"
      data-bs-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-header">
            <h5 v-if="action === 'edit'" class="modal-title" id="actionModalLabel">Edit contact</h5>
            <h5 v-else-if="action === 'submit'" class="modal-title" id="actionModalLabel">
              Submit contact
            </h5>
            <h5 v-else="action === 'delete'" class="modal-title" id="actionModalLabel">
              Delete contact
            </h5>
            <button
              @click="countryCode = ''"
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref="actionModalClose"
            ></button>
          </div>

          <div class="modal-body" style="padding: 20px 20px">
            <div v-if="action === 'delete'" class="d-flex align-items-center">
              Please confirm that you want this contact to be deleted.
            </div>

            <div v-if="action === 'edit'" class="form-group flex-grow-1 mr-2">
              <div class="form-group m-label-left">
                <input id="name" type="text" class="form-control" v-model="contact.first_name" />
                <label for="name">First Name</label>
              </div>

              <div class="form-group m-label-left">
                <input id="lastname" type="text" class="form-control" v-model="contact.last_name" />
                <label for="lastname">Last Name</label>
              </div>

              <div class="form-group m-label-left">
                <input
                  disabled
                  id="email"
                  type="text"
                  class="form-control"
                  v-model="contact.email"
                />
                <label for="email">Email</label>
              </div>

              <div class="form-group m-label-left">
                <input id="title" type="text" class="form-control" v-model="contact.title" />
                <label for="title">Title</label>
              </div>

              <div class="row">
                <div class="form-group m-label col-md-5 newmarket no-hor">
                  <v-select
                    id="country-code"
                    @input="addCountryCode(countryCode)"
                    style="font-size: 14px; height: 42px"
                    v-model="countryCode"
                    :options="[...getAllCountries].map(item => `${item.phone_code} ${item.name}`)"
                    :clearable="false"
                  >
                    <template v-slot:option="option">
                      {{ option.label }}
                    </template>
                  </v-select>
                  <label for="country-code">Country Code</label>
                </div>

                <div class="form-group m-label-left col-md-7">
                  <input
                    id="phone"
                    type="text"
                    class="form-control"
                    v-model="contact.phone_number"
                  />
                  <label for="phone">Phone number</label>
                </div>
              </div>

              <div class="form-group m-label-left">
                <input id="linkedin" type="text" class="form-control" v-model="contact.linkedin" />
                <label style="text-transform:unset!important" for="linkedin">linkedIn</label>
              </div>

              <div class="form-group m-label-left">
                <select v-model="contact.language" class="form-control">
                  <option value="danish">Danish</option>
                  <option value="dutch">Dutch</option>
                  <option value="english">English</option>
                  <option value="finnish">Finnish</option>
                  <option value="french">French</option>
                  <option value="german">German</option>
                  <option value="icelandic">Icelandic</option>
                  <option value="norwegian">Norwegian</option>
                  <option value="polish">Polish</option>
                  <option value="spanish">Spanish</option>
                  <option value="swedish">Swedish</option>
                </select>
                <label style="text-transform:unset!important" for="linkedin">Language</label>
              </div>

              <div class="form-group m-label-left">
                <input
                  id="adjob"
                  type="text"
                  class="form-control"
                  v-model="contact.advertised_job"
                />
                <label for="adjob">Advertised job</label>
              </div>
              <div style="margin-left: 5px; margin-bottom: 12px;" class="form-check addcont">
                <input
                  disabled
                  v-model="contact.only_newsletter"
                  class="form-check-input"
                  type="checkbox"
                  id="flexCheckDefault"
                />
                <label
                  style="opacity: 1!important; color: #111!important;"
                  class="form-check-label"
                  for="flexCheckDefault"
                >
                  Only include for
                  <span style="text-transform: capitalize!important;">Tech Talents Insights</span>
                  Newsletter
                </label>
              </div>
              <p>
                If the contact has previously been submitted to HubSpot, saving will cause the
                information there to be updated.
              </p>
            </div>

            <div v-if="action === 'submit'" class="d-flex align-items-center">
              Please confirm that you want this contact to be added to or updated in HubSpot. The
              contact will be added regardless of the results from the email verification. If the
              contact already exists in HubSpot, some of its data may be overwritten.
            </div>
          </div>

          <div v-if="action === 'delete'" class="modal-footer text-center justify-content-center">
            <button
              :disabled="isActionPerforming"
              @click="deleteContact(contact.id)"
              type="button"
              class="btn btn-primary"
            >
              Delete
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cancel
            </button>
          </div>

          <div v-if="action === 'edit'" class="modal-footer text-center justify-content-center">
            <button
              :disabled="isActionPerforming"
              @click="editContact"
              type="button"
              class="btn btn-primary"
            >
              Save
            </button>
            <button
              @click="countryCode = ''"
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
          </div>

          <div v-if="action === 'submit'" class="modal-footer text-center justify-content-center">
            <button
              :disabled="isActionPerforming"
              @click="submitContact"
              type="button"
              class="btn btn-primary"
            >
              Submit
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { displayResultsBasedOnScreenHeightMixin } from '../../../mixins/displayResultsBasedOnScreenHeightMixin';
import { mapActions, mapGetters } from 'vuex';
import Pagination from '@/components/Navigations/Pagination';

import Search from '../../common/Search/Search';
import { employmentMixin } from '../../../mixins/employmentMixin';
import { serviceLevelMixin } from '../../../mixins/serviceLevelMixin';
import { jobStatusMixin } from '../../../mixins/jobStatusMixin';
import { stagesMixin } from '../../../mixins/stagesMixin';
import { statusMixin } from '../../../mixins/statusMixin';
import titleMixin from '../../../mixins/titleMixin';
import ErrorList from '@/components/common/errorsList';
import axios from 'axios';

export default {
  components: {
    Pagination,
    Search,
    ErrorList,
  },
  mixins: [
    titleMixin,
    displayResultsBasedOnScreenHeightMixin,
    employmentMixin,
    serviceLevelMixin,
    jobStatusMixin,
    statusMixin,
    stagesMixin,
  ],
  title() {
    return 'Contacts Marketing | Jobshark';
  },
  data: () => ({
    mailIcon: `<svg height="30" id="Glyph" viewBox="0 0 64 64" width="30" xmlns="http://www.w3.org/2000/svg">
  <path d="m26.82 32c-3.31617-3.22622-7.52377-7.36013-10.82-10.57v21.14c1.26408-1.24446 9.37055-9.15463 10.82-10.57z"/>
  <path d="m48 21.43c-3.27936 3.2124-7.51574 7.35022-10.81 10.57 1.46 1.42986 9.53517 9.33167 10.81 10.57z"/>
  <path d="m29.68 32.01a3.0655 3.0655 0 0 0 4.42.22c1.07483-1.04416 10.583-10.346 12.5-12.23h-29.2s9.4 9.22265 12.28 12.01z"/>
  <path d="m46.42 43.82c-1.14841-1.09419-9.32561-9.1256-10.66-10.42a5.058 5.058 0 0 1 -7.5-.00005c-1.44847 1.41518-9.64694 9.42318-10.85005 10.60005h29.19005z"/>
</svg>
`,
    multipleMailIcon: `
<svg id="Glyph" height="30" viewBox="0 0 64 64" width="30" xmlns="http://www.w3.org/2000/svg"><path d="m30.707 7.707.293-.293v2.9195a1.00019 1.00019 0 0 0 2-.00007v-2.91937l.293.293a1.00008 1.00008 0 0 0 1.414-1.4141l-1.99966-1.99969a1.00952 1.00952 0 0 0 -1.41468 0l-1.99966 1.99973a1.00008 1.00008 0 0 0 1.414 1.414z"/><path d="m12.9082 16.73633c.78565-.00887 1.08493-.72252.99995-1.41408l2.064 2.064a1.00008 1.00008 0 0 0 1.414-1.4141l-2.06388-2.06395h.41406a1.00019 1.00019 0 0 0 -.00006-2h-2.82807a1.01 1.01 0 0 0 -1 1v2.82812a1.00006 1.00006 0 0 0 1 1.00001z"/><path d="m10.3335 31h-2.91944l.293-.293a1.00008 1.00008 0 0 0 -1.4141-1.414l-1.99969 1.99966a1.00951 1.00951 0 0 0 0 1.41468l1.99973 1.99966a.99988.99988 0 1 0 1.414-1.414l-.29294-.293h2.91944a1.00019 1.00019 0 0 0 0-2z"/><path d="m15.97217 46.61377-2.064 2.064v-.41406a1.00019 1.00019 0 0 0 -2 .00006c.01252 4.34886-.51862 3.815 3.82815 3.828a1.00017 1.00017 0 0 0 -.00009-2h-.414l2.064-2.064a1.00008 1.00008 0 0 0 -1.41406-1.414z"/><path d="m33.293 56.293-.293.293v-2.9195a1.00019 1.00019 0 0 0 -2 .00007v2.91937l-.293-.293a1.00008 1.00008 0 0 0 -1.414 1.4141l1.99964 1.99966a1.008 1.008 0 0 0 1.41468 0l1.99968-1.9997a1.00008 1.00008 0 0 0 -1.414-1.414z"/><path d="m51.0918 47.26367c-.7856.00893-1.08495.72244-.99995 1.41408l-2.064-2.064a1.00008 1.00008 0 0 0 -1.414 1.4141l2.06391 2.06393h-.41406a1.00019 1.00019 0 0 0 .00006 2h2.82804a1.01 1.01 0 0 0 1-1v-2.82811a1.00006 1.00006 0 0 0 -1-1z"/><path d="m59.92279 32.38214a1.00669 1.00669 0 0 0 -.21607-1.08948l-1.99972-1.99966c-1.25255-1.01007-2.42868.80682-1.121 1.707h-2.9195a1.00019 1.00019 0 0 0 .00007 2h2.91937l-.293.293a.99989.99989 0 1 0 1.41406 1.414 26.98526 26.98526 0 0 0 2.21579-2.32486z"/><path d="m51.47394 11.98541a27.4927 27.4927 0 0 0 -3.21027-.07723 1.0002 1.0002 0 0 0 .00006 2h.414l-2.064 2.064a.99989.99989 0 0 0 1.41406 1.41406l2.064-2.064v.41406a1.00019 1.00019 0 0 0 2-.00006v-2.82804a1.00731 1.00731 0 0 0 -.61785-.92279z"/><path d="m26.82 32c-3.31617-3.22622-7.52377-7.36013-10.82-10.57v21.14c1.26408-1.24446 9.37055-9.15463 10.82-10.57z"/><path d="m48 21.43c-3.27936 3.2124-7.51574 7.35022-10.81 10.57 1.46 1.42986 9.53517 9.33167 10.81 10.57z"/><path d="m29.68 32.01a3.0655 3.0655 0 0 0 4.42.22c1.07483-1.04416 10.583-10.346 12.5-12.23h-29.2s9.4 9.22265 12.28 12.01z"/><path d="m46.42 43.82c-1.14841-1.09419-9.32561-9.1256-10.66-10.42a5.058 5.058 0 0 1 -7.5-.00005c-1.44847 1.41518-9.64694 9.42318-10.85005 10.60005h29.19005z"/></svg>`,
    countryCode: '',
    action: 'edit',
    isActionPerforming: false,
    isPreviouslySubmited: false,
    searchText: '',
    pageCount: 10,
    currentPage: 1,
    totalPages: 1,
    employers: [],
    isLoading: false,
    contact: {},
    contacts: [],
    employersDropdown: [],
    selectedEmployers: [],
    selectedCountry: '',
    users: [],
    selectedUsers: [],
    selectedDate: '',
    dates: [
      {
        label: 'Last 7 days',
        value: '7',
      },
      {
        label: 'Last 30 days',
        value: '30',
      },
      {
        label: 'Last 90 days',
        value: '90',
      },
      {
        label: 'Last 365 days',
        value: '365',
      },
    ],
    linkedinIcon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.0.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M512 96L127.9 96C110.3 96 96 110.5 96 128.3L96 511.7C96 529.5 110.3 544 127.9 544L512 544C529.6 544 544 529.5 544 511.7L544 128.3C544 110.5 529.6 96 512 96zM231.4 480L165 480L165 266.2L231.5 266.2L231.5 480L231.4 480zM198.2 160C219.5 160 236.7 177.2 236.7 198.5C236.7 219.8 219.5 237 198.2 237C176.9 237 159.7 219.8 159.7 198.5C159.7 177.2 176.9 160 198.2 160zM480.3 480L413.9 480L413.9 376C413.9 351.2 413.4 319.3 379.4 319.3C344.8 319.3 339.5 346.3 339.5 374.2L339.5 480L273.1 480L273.1 266.2L336.8 266.2L336.8 295.4L337.7 295.4C346.6 278.6 368.3 260.9 400.6 260.9C467.8 260.9 480.3 305.2 480.3 362.8L480.3 480z"/></svg>`,
  }),
  methods: {
    ...mapActions([
      'retrieveEmployersDropdown',
      'retrieveReviewJobs',
      'approveReviewJob',
      'rejectReviewJob',
      'retrieveFreelancerDocumentPreviewAdmin',
    ]),

    getLanguageFlag(language) {
      const languageFlagMap = {
        danish: 'dk',
        dutch: 'nl',
        english: 'gb',
        finnish: 'fi',
        french: 'fr',
        german: 'de',
        icelandic: 'is',
        norwegian: 'no',
        polish: 'pl',
        spanish: 'es',
        swedish: 'se',
      };
      return languageFlagMap[(language || '').toLowerCase()] || 'gb';
    },

    getLanguageName(language) {
      const lang = (language || '').toLowerCase();
      const known = [
        'danish',
        'dutch',
        'english',
        'finnish',
        'french',
        'german',
        'icelandic',
        'norwegian',
        'polish',
        'spanish',
        'swedish',
      ];
      const display = known.includes(lang) ? lang : 'english';
      return display.charAt(0).toUpperCase() + display.slice(1);
    },

    getIconColor(status) {
      if (status === 0) {
        return { fill: '#a3a6b4' };
      } else if (status === 1) {
        return { fill: '#c8c8c8', opacity: 0.5 };
      } else {
        return { fill: '#a3a6b4' };
      }
    },

    setAction(contact, action) {
      this.action = action;
      this.contact = { ...contact };
    },

    doSearch(searchedText) {
      this.searchText = searchedText;

      this.currentPage = 1;
      this.handleSearchFilters();
    },

    deleteContact(id) {
      this.isActionPerforming = true;
      axios
        .delete(`${process.env.VUE_APP_API_URL}/marketing/contact/delete`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              `${process.env.VUE_APP_TOKEN_PREFIX}token`,
            )}`,
          },
          data: { contact_id: id },
        })
        .then(() => {
          this.isActionPerforming = false;
          this.$toasted.error('Contact deleted', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
          this.$refs.actionModalClose.click();
          this.handleSearchFilters();
        })
        .catch(err => {
          this.isActionPerforming = false;
        });
    },

    editContact() {
      this.isActionPerforming = true;
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/marketing/contact/update`,
          {
            contact_id: this.contact.id,
            first_name: this.contact.first_name,
            last_name: this.contact.last_name,
            title: this.contact.title,
            phone_number: this.contact.phone_number,
            linkedin: this.contact.linkedin,
            language: this.contact.language,
            advertised_job: this.contact.advertised_job,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(() => {
          this.$toasted.success('Contact updated', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
          this.isActionPerforming = false;
          this.$refs.actionModalClose.click();
          this.handleSearchFilters();
          this.countryCode = '';
        })
        .catch(() => {
          this.isActionPerforming = false;
          this.$toasted.success('There was an error communicating with the server', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },

    submitContact() {
      this.isActionPerforming = true;
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/marketing/contact/submit`,
          {
            contact_id: this.contact.id,
            first_name: this.contact.first_name,
            last_name: this.contact.last_name,
            title: this.contact.title,
            phone_number: this.contact.phone_number,
            linkedin: this.contact.linkedin,
            advertised_job: this.contact.advertised_job,
            language: this.contact.language,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(() => {
          this.$toasted.success('Contact submitted', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
          this.isActionPerforming = false;
          this.$refs.actionModalClose.click();
          this.handleSearchFilters();
          this.countryCode = '';
        })
        .catch(() => {
          this.isActionPerforming = false;
          this.$toasted.error('There was an error communicating with the server', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },

    addCountryCode(code) {
      this.countryCode = code.replace(/[0-9+]/g, '');
      this.contact.phone_number = code.substring(0, code.indexOf(' ')) + ' ';
    },

    handleSearchFilters() {
      this.isLoading = true;
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/marketing/contact/search`,
          {
            search_word: this.searchText,
            page: this.currentPage,
            count: 10,
            date: this.selectedDate ? this.selectedDate : 'all_time',
            js_profile_ids: this.selectedUsers,
            mm_employers_ids: this.selectedEmployers,
            country: this.selectedCountry,
            include_declined_contacts: this.isPreviouslySubmited,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(res => {
          this.contacts = res.data.data;
          this.totalPages = res.data.last_page;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    handleSearchFiltersNew() {
      this.currentPage = 1;
      this.isLoading = true;
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/marketing/contact/search`,
          {
            search_word: this.searchText,
            page: this.currentPage,
            count: 10,
            date: this.selectedDate ? this.selectedDate : 'all_time',
            js_profile_ids: this.selectedUsers,
            mm_employers_ids: this.selectedEmployers,
            country: this.selectedCountry,
            include_declined_contacts: this.isPreviouslySubmited,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(res => {
          this.contacts = res.data.data;
          this.totalPages = res.data.last_page;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    keymonitor(event) {
      // who caused it? "event.target.id"
      // console.log('keyup from id: ' + event.target.id);

      // what was pressed?
      let keyMessage = event.key || String.fromCharCode(event.keyCode);

      /* if (event.shiftKey) {
        keyMessage += 'Shift+';
      } */

      if (keyMessage == 'ArrowRight') {
        // this.nextPage();
      }

      if (keyMessage == 'ArrowLeft') {
        // this.previousPage();
      }
    },
    nextPage() {
      if (this.currentPage >= 1) {
        this.isLoading = true;
        this.currentPage++;
        this.handleSearchFilters();
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.isLoading = true;
        --this.currentPage;

        this.handleSearchFilters();
      } else {
        this.currentPage = 1;
      }
    },
    setPageByNumber(pageNumber) {
      if (pageNumber > this.totalPages || pageNumber < 1) return;
      this.isLoading = true;
      this.currentPage = pageNumber;

      this.handleSearchFilters();
    },
    setToFirstPage() {
      this.isLoading = true;
      this.currentPage = 1;

      this.handleSearchFilters();
    },
    setToLastPage(lastPage) {
      this.isLoading = true;
      this.currentPage = lastPage;

      this.handleSearchFilters();
    },

    getMarketingEmployerContacts() {
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/marketing/contact/search`,
          {
            search_word: this.searchText,
            page: this.currentPage,
            count: 10,
            date: this.selectedDate.length === 0 ? 'all_time' : this.selectedDate,
            js_profile_ids: [],
            mm_employers_ids: [],
            include_declined_contacts: this.isPreviouslySubmited,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(res => {
          this.contacts = res.data.data;
          this.totalPages = res.data.last_page;
          this.isLoading = false;
        })
        .catch(err => {
          console.log(err);
        });
    },

    getAllEmployers() {
      axios
        .get(`${process.env.VUE_APP_API_URL}/marketing/employers/dropdown`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              `${process.env.VUE_APP_TOKEN_PREFIX}token`,
            )}`,
          },
        })
        .then(res => {
          this.employersDropdown = Object.entries(res.data).map(([id, name]) => ({ id, name }));
        })
        .catch(err => {
          console.log(err);
        });
    },

    getAllUsers() {
      axios
        .get(`${process.env.VUE_APP_API_URL}/marketing/contact/getusers`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              `${process.env.VUE_APP_TOKEN_PREFIX}token`,
            )}`,
          },
        })
        .then(res => {
          this.users = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
  },
  computed: {
    ...mapGetters([
      'getEmployersDropdown',
      'getUserProfile',
      'getCurrentPage',
      'getTotalPages',
      'getAllCountries',
      'getAccType',
    ]),
  },
  mounted() {
    this.isLoading = true;
    this.getMarketingEmployerContacts();
    this.getAllEmployers();
    this.getAllUsers();

    this.isLoading = false;
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.icon-wrapper {
  .svg-icon {
    width: 18px;
    height: 18px;
  }

  .edit {
    fill: #a7a7a7;
  }

  .submit {
    fill: #5bb75b;
  }
}

.icons {
  display: flex;
  align-items: center;
  .svg-icon {
    &:last-child {
      width: 30px;
      margin-left: 30px;
    }
  }
}

.modal-body {
  p {
    margin-bottom: 0;
  }
}

.fa-briefcase {
  font-size: 18px;
}

.icon-wrapper {
  .svg-icon {
    width: 18px;
    height: 18px;
  }

  /*  a {
    fill: #28a745;

    &:hover {
      fill: #1e8035;
    }
  } */

  /* a:not(:first-child) {
    fill: #f02800;

    &:hover {
      fill: #b61e00;
    }
  } */
}

.mobile-only {
  display: none;
}

.desktop-only {
  display: block;
}

.desktop-only-table {
  display: table;
  table-layout: auto;
  table-layout: auto;
}

.controls-wrap {
  width: 100%;
  .integration-group {
    width: 39.3%;
  }
}

.card {
  height: 81.7vh;
}

@media only screen and (max-width: 1251px) {
  .card {
    margin: 24px 23px 0 23px !important;
  }
}

@media only screen and (max-width: 992px) {
  .card {
    min-height: 100vh;
    margin: 24px 0px 0 0px !important;
  }
  .mobile-qualification {
    font-family: $font-family-sans-lato;
    display: block;
    .list-unstyled {
      li {
        a {
          text-decoration: none;
        }
        .job-ad-title {
          display: block;
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 4px;
        }
        .company-name {
          color: $color-orange;
          font-size: 15px;
          margin-bottom: 5px;
        }
        .date {
          color: #5f5f5f;
        }
        position: relative;
        border-bottom: 1px solid #ddd;
        padding: 9px 18px 15px 18px;
        .svg-icon {
          width: 22px;
          height: 22px;
          display: inline-block;
        }
        .action-buttons {
          margin-top: 8px;
          .svg-icon {
            width: 22px;
            height: 22px;
            display: inline-block;
          }
          .green {
            fill: #28a745;
          }
          .red {
            fill: #f02800;
            margin-left: 10px;
          }
        }
      }
    }
  }
  .controls-wrap {
    width: 100%;
    .integration-group {
      width: 100%;
    }
  }
  .mobile-only {
    display: block;
  }

  .desktop-only {
    display: none;
  }

  .desktop-only-table {
    display: none;
  }
}

@media only screen and (max-width: 768px) {
  .card {
    min-height: 100vh;
  }
  .mobile-qualification {
    font-family: $font-family-sans-lato;
    display: block;
    .list-unstyled {
      li {
        a {
          text-decoration: none;
        }
        .job-ad-title {
          display: block;
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 4px;
        }
        .company-name {
          color: $color-orange;
          font-size: 15px;
          margin-bottom: 5px;
        }
        .date {
          color: #5f5f5f;
        }
        position: relative;
        border-bottom: 1px solid #ddd;
        padding: 9px 18px 15px 18px;
        .svg-icon {
          width: 22px;
          height: 22px;
          display: inline-block;
        }
        .action-buttons {
          margin-top: 8px;
          .svg-icon {
            width: 22px;
            height: 22px;
            display: inline-block;
          }
          .green {
            fill: #28a745;
          }
          .red {
            fill: #f02800;
            margin-left: 10px;
          }
        }
      }
    }
  }
  .controls-wrap {
    width: 100%;
    .integration-group {
      width: 100%;
    }
  }
  .mobile-only {
    display: block;
  }

  .desktop-only {
    display: none;
  }

  .desktop-only-table {
    display: none;
  }
}

@media only screen and (max-width: 576px) {
  #wrapper {
    .card {
      min-height: 100vh !important;
      margin-top: 0 !important;
    }
  }
  .mobile-qualification {
    font-family: $font-family-sans-lato;
    display: block;
    .list-unstyled {
      li {
        a {
          text-decoration: none;
        }
        .job-ad-title {
          display: block;
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 4px;
        }
        .company-name {
          color: $color-orange;
          font-size: 15px;
          margin-bottom: 5px;
        }
        .date {
          color: #5f5f5f;
        }
        position: relative;
        border-bottom: 1px solid #ddd;
        padding: 9px 18px 15px 18px;
        .svg-icon {
          width: 22px;
          height: 22px;
          display: inline-block;
        }
        .action-buttons {
          margin-top: 8px;
          .svg-icon {
            width: 22px;
            height: 22px;
            display: inline-block;
          }
          .green {
            fill: #28a745;
          }
          .red {
            fill: #f02800;
            margin-left: 10px;
          }
        }
      }
    }
  }
  .controls-wrap {
    width: 100%;
    .integration-group {
      width: 100%;
    }
  }
  .mobile-only {
    display: block;
  }

  .desktop-only {
    display: none;
  }

  .desktop-only-table {
    display: none;
  }
}
</style>
